import { useEffect, useState } from "react";
import logo from "../assets/Logoes/mainLogo.png";
const Footer = () => {
  let date_2 = new Date("January 1, 2030 00:00:00").getTime();
  let [sec, setSec] = useState(0);

  useEffect(() => {
    let interval;
    clearInterval(interval);
    if (Date.now() !== date_2) {
      interval = setInterval(() => {
        let date_1 = new Date().getTime();
        let date_3 = date_2 - date_1;
        let date_4 = date_3 / 1000;
        setSec(Math.ceil(date_4));
      }, 1000);
    }
  }, [date_2]);

  return (
    <div className="footer">
      <div>
        <h3>Lounch time: January 1st, 2030</h3>
        <div className="sec_left">{sec} second left...</div>
      </div>
      <div>
        <img
          src={logo}
          alt="Planet"
          style={{ width: "5rem", height: "5rem" }}
        />
      </div>
    </div>
  );
};

export default Footer;
